﻿export type ResultatValg = ResultatValgVisning;

export interface ResultatValgVisning {
    visStudieforberedendeBa: boolean;
    visYrkesfagBb: boolean;
    visAarCa: boolean;
    visAarCb: boolean;
    visAarCc: boolean;
    visAarCd: boolean;
    visAarCe: boolean;
    visProgramDa: boolean;
    visProgramDb: boolean;
    visProgramDc: boolean;
    visProgramDd: boolean;
    visProgramDdVg3: boolean;
    visProgramDe: boolean;
    visUtstyrsstipendEa: boolean;
    visUtstyrsstipendEb: boolean;
    visUtstyrsstipendEc: boolean;
    visUtstyrsstipendEd: boolean;
    visUtstyrsstipendEe: boolean;
    visGenerellFeil: boolean;
}

export const SET_VISNING = 'SET_VISNING';

export interface SetVisningAction {
    type: typeof SET_VISNING;
    payload: Partial<ResultatValgVisning>;
}

export type ResultatActionTypes = SetVisningAction;
